/* BRILIAX v2 interactions */
(function(){
  // reveal on scroll
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  },{threshold:.12});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  // header shrink
  var hdr = document.querySelector('.site-header');
  function onScroll(){
    if(hdr) hdr.classList.toggle('scrolled', window.scrollY > 24);
    var bar = document.querySelector('.sticky-atc');
    if(bar){
      var form = document.querySelector('.pd-form');
      var past = form ? form.getBoundingClientRect().bottom < 0 : window.scrollY > 700;
      bar.classList.toggle('show', past);
    }
  }
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

  // faq accordions (delegated, works for .faq-item and .pd-acc)
  document.addEventListener('click', function(ev){
    var q = ev.target.closest('.faq-q'); if(!q) return;
    var item = q.parentElement, ans = item.querySelector('.faq-a');
    var open = item.classList.toggle('open');
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
    ans.style.maxHeight = open ? ans.scrollHeight + 'px' : '0px';
  });

  // product gallery
  document.addEventListener('click', function(ev){
    var t = ev.target.closest('.gal-thumbs button'); if(!t) return;
    document.querySelectorAll('.gal-thumbs button').forEach(function(b){ b.classList.remove('active'); });
    t.classList.add('active');
    var main = document.querySelector('.gal-main img');
    var thumb = t.querySelector('img');
    if(main && t.dataset.src){
      main.src = t.dataset.src;
      if(thumb && thumb.alt) main.alt = thumb.alt;
    }
  });

  // copy discount code (contact success page)
  document.addEventListener('click', function(ev){
    var b = ev.target.closest('.popup-copy'); if(!b) return;
    var code = document.getElementById('contactCode');
    var txt = code ? code.textContent.trim() : '';
    function done(){ b.textContent = 'Copied'; setTimeout(function(){ b.textContent = 'Copy'; }, 1800); }
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(txt).then(done, done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = txt; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch(e){}
      document.body.removeChild(ta); done();
    }
  });

  // animated counters
  var cio = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      cio.unobserve(e.target);
      var el = e.target, target = parseInt(el.dataset.count, 10), t0 = null;
      function tick(ts){
        if(!t0) t0 = ts;
        var u = Math.min(1, (ts - t0) / 1400), v = 1 - Math.pow(1 - u, 3);
        el.textContent = Math.round(target * v).toLocaleString('en-US');
        if(u < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  },{threshold:.4});
  document.querySelectorAll('[data-count]').forEach(function(el){ cio.observe(el); });

  // smooth anchor offset for fixed header
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(ev){
      var id = a.getAttribute('href');
      if(id.length < 2) return;
      var t = document.querySelector(id);
      if(t){ ev.preventDefault(); t.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });
})();